import { FC, ReactNode, useMemo } from 'react';

import { RootState } from 'store/rootReducer';

import { useAppSelector } from 'hooks/defaultStoreHooks';

import { DrawerSection } from 'components/drawerSections/DrawerSections';
import UtkastList from 'components/utkastList/UtkastList';

import { BebyggelseobjektgruppEnum, SkyddstypEnum } from 'enums';

export const SkyddsklassningKkmUtkastObjektSection: FC = (): ReactNode => {
  const user = useAppSelector((state: RootState) => state.user.data);
  const aktivitet = useAppSelector((state: RootState) => state.aktivitet);
  const bebyggelseobjektUtkast = useAppSelector((state: RootState) => state.bebyggelseobjektUtkast);
  const utkastsWithErrors = aktivitet.error?.error_fields;

  const utkast = useMemo(() => {
    return bebyggelseobjektUtkast.data?.filter(
      (utkastIndex) =>
        utkastIndex.bebyggelseobjektgrupp === BebyggelseobjektgruppEnum.ENSKILT_BEBYGGELSEOBJEKT &&
        utkastIndex.skydd.skyddstyp === SkyddstypEnum.KYRKLIGT_KULTURMINNE
    );
  }, [bebyggelseobjektUtkast.data]);

  return (
    <DrawerSection>
      <h2 className="tw-heading-md">Berörda objekt</h2>
      {aktivitet.error && <p className="tw-text-raa-error-red">{aktivitet.error.message}</p>}
      <UtkastList
        list={utkast}
        error={bebyggelseobjektUtkast.error}
        user={user}
        requestStatus={bebyggelseobjektUtkast.requestStatus}
        utkastsWithErrors={utkastsWithErrors}
      />
    </DrawerSection>
  );
};
